module.exports = __webpack_public_path__ + "img/xiansuoliuzhuan.045c7711.png";